import { cva, type VariantProps } from "class-variance-authority";

export const raisedTrackVariants = cva(
  "bg-muted text-muted-foreground inline-flex w-fit items-center justify-center rounded-sm",
  {
    variants: {
      size: {
        default: "h-9 p-[3px]",
        sm: "h-8 p-[3px]",
        xs: "h-7 p-0.5",
        "2xs": "h-6 p-0.5",
      },
    },
    defaultVariants: {
      size: "default",
    },
  },
);

export type RaisedSize = VariantProps<typeof raisedTrackVariants>["size"];

export const raisedItemVariants = cva(
  "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:outline-ring text-foreground dark:text-muted-foreground inline-flex h-[calc(100%-1px)] flex-1 cursor-pointer items-center justify-center gap-1.5 rounded-sm border border-transparent font-medium whitespace-nowrap transition-[color,box-shadow] focus-visible:ring-[3px] focus-visible:outline-1 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 raised-selected:bg-background raised-selected:shadow-sm dark:raised-selected:text-foreground dark:raised-selected:border-input dark:raised-selected:bg-input/30",
  {
    variants: {
      size: {
        default: "px-2 py-1 text-sm [&_svg:not([class*='size-'])]:size-4",
        sm: "px-2 py-0.5 text-sm [&_svg:not([class*='size-'])]:size-4",
        xs: "px-1.5 py-0.5 text-xs [&_svg:not([class*='size-'])]:size-3.5",
        "2xs": "px-1.5 py-0 text-xs [&_svg:not([class*='size-'])]:size-3",
      },
    },
    defaultVariants: {
      size: "default",
    },
  },
);
